// extracted by mini-css-extract-plugin
export default {"menu":"_2fE1lCF9AtFF99hbFtCjAN"};